import { Controller } from 'stimulus'

import FilterCollection from '../packs/classes/filter_collection'

export default class extends Controller {
  static targets = []

  connect() {
    new FilterCollection()
  }
}
